/**
 * Node의 `process`를 브라우저에 맞춰 둡니다.
 * vite.config `resolve.alias`로 `process` → `process/browser.js` 연결.
 */
import process from 'process';

const g = globalThis as typeof globalThis & { process: typeof process };
g.process = process;

const env = process.env as Record<string, string>;
for (const key of Object.keys(import.meta.env)) {
  const v = (import.meta.env as Record<string, string | boolean | undefined>)[key];
  env[key] = v === undefined || v === null ? '' : String(v);
}
env.NODE_ENV = import.meta.env.DEV ? 'development' : 'production';
